// src/components/ProfilePage.js
import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";
import "./ProfilePage.css";

const ProfilePage = ({ onBack, onLogout }) => {
  const [user, setUser] = useState(null);
  const [passwordData, setPasswordData] = useState({ oldPassword: "", newPassword: "" });
  const [message, setMessage] = useState("");
  const [watchlist, setWatchlist] = useState([]);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
        const parsed = JSON.parse(savedUser);
    setUser(parsed);
      setUser(JSON.parse(savedUser));

    
    // fetch watchlist
    fetch(`${API_BASE_URL}/watchlist?email=${parsed.email}`, {
      method: "GET",
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
               console.log("📌 Watchlist API response:", data);  // 👈 Verify here
        if (data.status === "success") {
          setWatchlist(data.watchlist);
        }
      })
      .catch(err => console.error("Error fetching watchlist:", err));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch(`${API_BASE_URL}/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          email: user.email,
          oldPassword: passwordData.oldPassword,
          newPassword: passwordData.newPassword,
        }),
      });

      const data = await response.json();
      if (response.ok && data.status === "success") {
        setMessage("✅ Password updated successfully");
      } else {
        setMessage(data.message || "❌ Failed to update password");
      }
    } catch (err) {
      setMessage("Server error, try again later.");
    }
  };

  return (
    <div className="profile-page">
      <header className="oil-header">
        <div className="oil-header-container">
          <div className="logo">
          <img src="images/Final Font Stocks4U1.png" className="logo-text" />
          </div>

          <div className="oil-user">
            <button className="oil-back-btn" onClick={onBack}>
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </header>
      {/* Top Bar */}
      <div className="profile-header">
        <h1>{user?.email?.split("@")[0]}</h1>
      </div>

      <p className="welcome-text">Welcome Back, {user?.email?.split("@")[0]} 👋</p>

      {/* Watchlist */}
<section className="watchlist-section">
  <h2>Your Watchlist</h2>
  <div className="watchlist-cards">
    {watchlist.length > 0 ? (
     <div className="watchlist-items">
      {watchlist.map((item, idx) => (
        <div key={idx} className="watchlist-card">
          <p>{item.symbol}</p>
          <small>{item.name}</small>
        </div>
      ))}
    </div>
      ) : (
      <p className="no-watchlist">No stocks in your watchlist.</p>
    )}
  </div>
</section>

     <div className="profile-grid">
        {/* Left Side */}
        <div className="profile-left">
          {/* Personal + Buy Details */}
          <div className="details-section">
            <div className="personal-details">
              <h3>Personal Details</h3>
              <p>👤 Name: {user?.email?.split("@")[0] || "User"}</p>
              <p>📧 Email: {user?.email}</p>
              <p>📱 Phone: +91-XXXXXXXXXX</p>
            </div>

            <div className="buy-details">
              <h3>Buy Details</h3>
              <p><span className="dot blue"></span> Dates: 25 Aug 2025</p>
              <p><span className="dot red"></span> Validity: 1 Year</p>
            </div>
          </div>

          {/* Security */}
          <div className="security-section">
            <h3>Security</h3>
            <form onSubmit={handlePasswordChange} className="password-form">
              <input
                type="password"
                name="oldPassword"
                placeholder="Current Password"
                value={passwordData.oldPassword}
                onChange={handleChange}
                required
              />
              <input
                type="password"
                name="newPassword"
                placeholder="New Password"
                value={passwordData.newPassword}
                onChange={handleChange}
                required
              />
              <button type="submit">Update Password</button>
            </form>
            {message && <p className="message">{message}</p>}
          </div>
        </div>

        {/* Right Side */}
        <div className="current-plan">
          <h3>Current Plan: Basic</h3>
          <ul>
            <li>✔ Track Top Gainers & Losers</li>
            <li>✔ Comprehensive Company Insights</li>
            <li>✔ Global Market Coverage</li>
          </ul>
          <button className="upgrade-btn">Upgrade To Pro</button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
